import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M4.667 6.666a.666.666 0 1 0-1.333.002.666.666 0 0 0 1.333-.002m1.333 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M3.333 5.334V2.667a.667.667 0 0 1 1.334 0v2.667a.667.667 0 0 1-1.334 0M3.333 13.333V8a.667.667 0 1 1 1.334 0v5.333a.667.667 0 0 1-1.334 0M8.667 10.666a.666.666 0 1 0-1.333.002.666.666 0 0 0 1.333-.002m1.333 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.333 9.334V2.667a.667.667 0 0 1 1.334 0v6.667a.668.668 0 0 1-1.334 0M7.333 13.333V12a.667.667 0 1 1 1.334 0v1.333a.667.667 0 0 1-1.334 0M12.667 4.666a.666.666 0 1 0-1.333.001.666.666 0 0 0 1.333 0m1.333 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.333 3.334v-.667a.667.667 0 0 1 1.334 0v.667a.668.668 0 0 1-1.334 0M11.333 13.333V6a.667.667 0 1 1 1.334 0v7.333a.667.667 0 0 1-1.334 0"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })